type MunicipalityNameMap = Map<string, string>;

let cachedMunicipalityNames: MunicipalityNameMap | null = null;
let loadingPromise: Promise<MunicipalityNameMap> | null = null;

const MUNICIPALITY_NAMES_SOURCE = '/data/municipalities-optimized.geojson';

async function fetchMunicipalityNames(): Promise<MunicipalityNameMap> {
  const response = await fetch(MUNICIPALITY_NAMES_SOURCE);
  if (!response.ok) {
    throw new Error(`Failed to load municipality names: ${response.status}`);
  }

  const geojson = await response.json();
  const map: MunicipalityNameMap = new Map();

  if (geojson && Array.isArray(geojson.features)) {
    geojson.features.forEach((feature: any) => {
      const code = typeof feature?.properties?.PRO_COM !== 'undefined'
        ? String(feature.properties.PRO_COM).trim().padStart(6, '0')
        : null;
      const name = typeof feature?.properties?.NOME === 'string'
        ? feature.properties.NOME.trim()
        : null;

      if (code && name && !map.has(code)) {
        map.set(code, name);
      }
    });
  }

  return map;
}

export async function getMunicipalityNames(): Promise<MunicipalityNameMap> {
  if (cachedMunicipalityNames) {
    return cachedMunicipalityNames;
  }

  if (!loadingPromise) {
    loadingPromise = fetchMunicipalityNames()
      .then((map) => {
        cachedMunicipalityNames = map;
        return map;
      })
      .catch((error) => {
        loadingPromise = null;
        throw error;
      });
  }

  return loadingPromise;
}

export function getMunicipalityNameSync(code: string | null | undefined): string | null {
  if (!code) {
    return null;
  }
  if (!cachedMunicipalityNames) {
    return null;
  }
  const normalized = code.trim().padStart(6, '0');
  return cachedMunicipalityNames.get(normalized) ?? null;
}
